import { isExperimentEnabled } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { isRemixOptedOut } from './isRemixOptedOut.ts';

/**
 * Returns whether remix features are available for the current user/site.
 *
 * Checks that:
 * 1. Rovo LLM is enabled on the site (isRovoLLMEnabled)
 * 2. The tenant/org has not opted out of remix — checked before the experiment
 *    so opted-out users do not fire a cc-maui-experiment exposure
 * 3. The MAUI experiment is enabled (cc-maui-experiment)
 *
 * Use this hook to gate all remix entrypoints (buttons, nudge icons, toolbars)
 * so they are completely hidden when remix is not available.
 */
// eslint-disable-next-line confluence-feature-gating/inline-usage
export const useIsRemixAvailable = (): boolean => {
	const { isRovoLLMEnabled } = useSessionData();
	return isRovoLLMEnabled && !isRemixOptedOut() && isExperimentEnabled('cc-maui-experiment');
};
